import AssignedStudentPrograms from "../../../../modules/academyProgramDetail/ui/programStudents/AssignedStudentPrograms";
import { WrapperModalAssignedStudentProgram } from "./styled";

export const ModalAssignedStudentProgram = ({
  openModal,
  setOpenModal,
  onSuccess,
}: {
  openModal: boolean;
  setOpenModal: (value: boolean) => void;
  onSuccess?: () => void;
}) => {
  return (
    <WrapperModalAssignedStudentProgram
      title={`Asignar estudiante al programa`}
      open={openModal}
      width={"320px"}
      destroyOnClose
      onClose={() => setOpenModal(false)}
    >
      <AssignedStudentPrograms
        setOpenModal={setOpenModal}
        onSuccess={onSuccess}
      />
    </WrapperModalAssignedStudentProgram>
  );
};
